import { render } from "./detect.vue?vue&type=template&id=59af0344&scoped=true&ts=true"
import script from "./detect.vue?vue&type=script&lang=ts"
export * from "./detect.vue?vue&type=script&lang=ts"

import "./detect.vue?vue&type=style&index=0&id=59af0344&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59af0344"]])

export default __exports__